import { gql } from '@apollo/client';

export const ADD_UPDATE_ENGINE_SCORING_GRID_HEADER = gql`
  mutation addOrUpdateEngineScoringGridHeader($input: EngineScoringGridHeaderInput) {
    addOrUpdateEngineScoringGridHeader(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_ENGINE_CLASSIFICATION = gql`
  mutation addOrUpdateEngineClassification($input: EngineClassificationInput) {
    addOrUpdateEngineClassification(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_ENGINE_SCORING_KNOCKOUT_CRITERION = gql`
  mutation addOrUpdateEngineScoringKnockoutCriterion($input: EngineScoringKnockoutCriterionInput) {
    addOrUpdateEngineScoringKnockoutCriterion(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_ENGINE_INTERVALS = gql`
  mutation addOrUpdateEngineIntervals($input: EngineIntervalsInput) {
    addOrUpdateEngineIntervals(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_ENGINE_RULES = gql`
  mutation addOrUpdateEngineRules($input: EngineRulesInput) {
    addOrUpdateEngineRules(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_ENGINE_EXTERNAL_SYSTEMS = gql`
  mutation addOrUpdateEngineExternalSystems($input: EngineExternalSystemsInput) {
    addOrUpdateEngineExternalSystems(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_ENGINE_EVALUATED_ATTRIBUTES = gql`
  mutation addOrUpdateEngineEvaluatedAttributes($input: EngineEvaluatedAttributesInput) {
    addOrUpdateEngineEvaluatedAttributes(input: $input) {
      commandId
    }
  }
`;

export const DELETE_ENGINE_CLASSIFICATION = gql`
  mutation deleteEngineScoringClassification($input: DeleteEngineScoringClassificationInput) {
    deleteEngineScoringClassification(input: $input) {
      commandId
    }
  }
`;

export const DELETE_ENGINE_KNOCKOUT_CRITERION = gql`
  mutation deleteEngineScoringKnockoutCriterion($input: DeleteEngineScoringKnockoutCriterionInput) {
    deleteEngineScoringKnockoutCriterion(input: $input) {
      commandId
    }
  }
`;

export const TEST_SCORING_GRID = gql`
  mutation testScoringGrid($input: TestScoringGridInput) {
    testScoringGrid(input: $input) {
      commandId
    }
  }
`;

export const DUPLICATE_ENGINE_SCORING = gql`
  mutation duplicateEngineScoringGrid($input: DuplicateEngineScoringGridInput) {
    duplicateEngineScoringGrid(input: $input) {
      commandId
    }
  }
`;

export const ENGINE_SCORING_CREATE_NEW_VERSION = gql`
  mutation newVersionEngineScoringGrid($input: NewVersionEngineScoringGridInput) {
    newVersionEngineScoringGrid(input: $input) {
      commandId
    }
  }
`;
